import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import errorBoundary from '@ifeng-fe/errorBoundary';
import { rel } from '@ifeng-fe/container_channel/common/client/utils/rel';
import Slides from '@ifeng-fe/ui_pc_slides';
import { oneChangeTwoDimensional } from '@ifeng-fe/container_channel/common/client/winter/utils/utils';

class Content extends React.PureComponent {
    static propTypes = {
        content: PropTypes.array,
        linkFengUrl: PropTypes.string,
    };

    // 跳转大凤号老师列表
    linkFeng = replaceID => {
        const { linkFengUrl } = this.props;

        return linkFengUrl.replace(/wemediaId/, replaceID);
    };

    sliderTmpl = itemOut =>
        itemOut.map((itemInner, index) => (
            <div className={styles.lvren_list} key={itemInner.wemediaId + index}>
                <img src={itemInner.background} className={styles.bg} />
                <div className={styles.bg04} />
                <div className={styles.lv_pic}>
                    <a
                        href={this.linkFeng(itemInner.wemediaId)}
                        alt={itemInner.title}
                        title={itemInner.title}
                        target="_blank"
                        rel={rel}>
                        <img src={itemInner.profilePicture} className={styles.title_pic} />
                    </a>
                </div>
                <div className={styles.lv_word}>
                    <h3>
                        <a
                            href={this.linkFeng(itemInner.wemediaId)}
                            alt={itemInner.title}
                            title={itemInner.title}
                            target="_blank"
                            rel={rel}>
                            {itemInner.name}
                        </a>
                    </h3>
                    <div className={styles.lv_map}>
                        <a href={itemInner.url} alt={itemInner.title} title={itemInner.title} target="_blank" rel={rel}>
                            {itemInner.location}
                        </a>
                    </div>
                    <p>{itemInner.summary}</p>
                </div>
            </div>
        ));

    /**
     * 渲染网页布局
     */
    render() {
        /**
         * 组件分发数据
         */
        const { content } = this.props;

        const num = 2;
        const slidesData = oneChangeTwoDimensional(content, num);

        const sliderConfig = {
            unitSize: 340,
            extension: 2,
            padding: 0,
            arrows: true,
            autoplay: true,
            dots: false,
            direction: 'forward',
            pauseOnHover: true,
            autoplayInterval: 5000,
            axis: 'horizonta',
            initialSlide: 0,
            speed: 300,
            infinite: true,
            sliderTmpl: this.sliderTmpl,
        };

        return (
            <div className={styles.sliderContainer}>
                <Slides content={slidesData} config={sliderConfig} />
            </div>
        );
    }
}

export default errorBoundary(Content);
